import { Predicate } from 'effect';
import { Profile } from '@modules/profile/model';
import { useProfile } from '@modules/profile/loader';

export function useProfilePredicate(predicate: Predicate.Predicate<Profile>) {
  return predicate(useProfile());
}
